import React, { useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../components/BreadCrumbs';
import { toast } from 'react-toastify';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from '../components/buttons/Button';
import InputField from '../components/inputFields/InputField';
import FormikDropdown from '../components/inputFields/FormikDropDown';
import ImagePicker from '../components/inputFields/ImagePicker';
import { postNotification } from '../services/notification';

function AddNotification() {
    const navigate = useNavigate();
    const [image, setShopLogo] = useState(null);

    const handleDiscardChanges = (resetForm) => {
        resetForm();
        navigate(-1);
    };

    const handleimageSelect = (file) => {
        setShopLogo(file);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        toast.info("Please wait we are sending notifications!");
        const formData = new FormData();
        if (image && typeof image === "object") {
            formData.append("image", image);
        }

        formData.append('title', values.title);
        formData.append('message', values.message);
        formData.append('to_redirect', values.to_redirect);

        try {
            const response = await postNotification(formData);

            if (response?.status === 200) {
                toast.success("Notification Pushed successfully!");
                navigate("/notification");
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Notifications', link: '/notification' },
            { name: 'Add Notification' },
        ]} />
        <div className="mt-8">
            <Formik
                initialValues={{
                    title: "",
                    message: "",
                    to_redirect: "",
                }}
                validationSchema={Yup.object({
                    title: Yup.string().required("Title is required"),
                    message: Yup.string().required("Message is required"),
                })}
                onSubmit={handleFormSubmit}
            >
                {({ isSubmitting, resetForm }) => (
                    <Form>
                        <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                            <div className="flex flex-col w-full">
                                <div className="grid gap-2 grid-cols-1 md:grid-cols-2">
                                    <InputField
                                        label="Title"
                                        name="title"
                                        type="text"
                                        placeholder="Title Of Notification"
                                        required
                                    />
                                    <FormikDropdown
                                        label="Redirection"
                                        name="to_redirect"
                                        placeholder="Redirection"
                                        options={[
                                            {
                                                label: "Shop",
                                                value: "shop",
                                            },
                                            {
                                                label: "Forecast",
                                                value: "forecast",
                                            },
                                            {
                                                label: "NPK Calculator",
                                                value: "calculator",
                                            },
                                            {
                                                label: "Satellite",
                                                value: "satellite",
                                            },
                                            {
                                                label: "Expense",
                                                value: "expense",
                                            },
                                            {
                                                label: "Practice",
                                                value: "practice",
                                            },
                                            {
                                                label: "Community",
                                                value: "community",
                                            },
                                            {
                                                label: "Forum",
                                                value: "forum",
                                            },
                                            {
                                                label: "Farm",
                                                value: "farm",
                                            },
                                        ]}
                                        needSearch
                                    />
                                </div>
                                <div className="flex gap-2 flex-col md:flex-row">
                                    <div className="h-48 aspect-video mx-2">
                                        <ImagePicker
                                            preloadedImage={image}
                                            placeholder='Select Image (16:9)'
                                            onImageSelect={handleimageSelect}
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <InputField
                                            label="Message"
                                            name="message"
                                            type="text"
                                            placeholder="Write your message here......"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="py-5 flex justify-end gap-6">
                                    <div>
                                        <Button
                                            type="button"
                                            className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                            onClick={() => handleDiscardChanges(resetForm)}
                                            disabled={isSubmitting}
                                        >
                                            Discard Changes
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Sending..." : "Save"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </>);
}

export default AddNotification;